import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DISCOVERY_PAGE_SIZE } from '@/constants/discoveryFilters';
import { UserProfile } from '@/types';

interface UIState {
  // App mechanics
  loaded: boolean;
  setLoaded: (loaded: boolean) => void;

  activeTab: 'grid' | 'chat' | 'profile';
  setActiveTab: (tab: 'grid' | 'chat' | 'profile') => void;

  selectedUser: UserProfile | null;
  setSelectedUser: (user: UserProfile | null) => void;

  activeConversationId: string | null;
  setActiveConversationId: (id: string | null) => void;

  /** How many discovery profiles the grid shows; survives route changes so
   *  returning from a profile keeps the loaded set instead of restarting. */
  discoveryDisplayCount: number;
  setDiscoveryDisplayCount: (count: number) => void;
}

export const useUIStore = create<UIState>()(
  persist(
    set => ({
      // App mechanics
      loaded: false,
      setLoaded: loaded => set({ loaded }),

      activeTab: 'grid',
      setActiveTab: tab => set({ activeTab: tab }),

      selectedUser: null,
      setSelectedUser: user => set({ selectedUser: user }),

      activeConversationId: null,
      setActiveConversationId: id => set({ activeConversationId: id }),

      discoveryDisplayCount: DISCOVERY_PAGE_SIZE,
      setDiscoveryDisplayCount: count => set({ discoveryDisplayCount: count }),
    }),
    {
      name: 'pulp-ui-storage',
      partialize: state => ({
        activeTab: state.activeTab,
        activeConversationId: state.activeConversationId,
      }),
    }
  )
);
